module.exports = __webpack_public_path__ + "img/global_banner.d0ccfd34.png";